module.exports = __webpack_public_path__ + "static/media/patrick101.27d9329a.png";